var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-media section-padding" }, [
    _c("h2", { staticClass: "text-center" }, [
      _vm._v(_vm._s(_vm.$t("message.home.as_seen_in")))
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-5" }, [
      _c("div", { staticClass: "col-12 mt-3 text-center" }, [
        _c("h2", { staticClass: "text-center" }, [
          _vm._v(_vm._s(_vm.$t("message.business.our_customer")))
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer06.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer02.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer05.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer08.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer03.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer01.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer07.jpg" }
        }),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer04.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer09.png" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer11.png" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer12.png" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer13.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer15.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer16.png" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer17.jpg" }
        }),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer18.png" }
        }),
        _vm._v(" "),
        _c("img", {
          staticStyle: { margin: "0 1rem", height: "70px" },
          attrs: { src: "/static/img/business-customer19.png" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer20.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer21.png" }
        }),
        _vm._v(" "),
        _c("img", {
          staticStyle: { margin: "0 1rem", height: "50px" },
          attrs: { src: "/static/img/business-customer22.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer23.jpg" }
        }),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer24.png" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer25.png" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer26.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer27.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer28.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer29.png" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          staticStyle: { margin: "0px 1rem", height: "60px" },
          attrs: { src: "/static/img/business-customer30.png" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer31.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer32.png" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer33.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          attrs: { src: "/static/img/business-customer34.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          staticStyle: { height: "90px" },
          attrs: { src: "/static/img/business-customer35.jpg" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "img-customer-brand",
          staticStyle: { height: "90px" },
          attrs: { src: "/static/img/business-customer36.png" }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 text-center" }, [
        _c(
          "a",
          {
            attrs: {
              href: "http://morning-news.bectero.com/economy/05-Sep-2016/86546",
              target: "_blank"
            }
          },
          [
            _c("img", {
              staticClass: "img-media",
              attrs: { src: "/static/img/media/media-ch3.jpg" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.youtube.com/watch?v=kjdeXO6o6Vw",
              target: "_blank"
            }
          },
          [
            _c("img", {
              staticClass: "img-media",
              attrs: { src: "/static/img/media/media-thaipbs.jpg" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://thestandard.co/ais-playground-startup/",
              target: "_blank"
            }
          },
          [
            _c("img", {
              staticClass: "img-media",
              attrs: { src: "/static/img/media/media-the-standard.png" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.youtube.com/watch?v=oLhqQodSKgw",
              target: "_blank"
            }
          },
          [
            _c("img", {
              staticClass: "img-media",
              attrs: { src: "/static/img/media/media-ch9.jpg" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "http://www.thairath.co.th/content/718370",
              target: "_blank"
            }
          },
          [
            _c("img", {
              staticClass: "img-media",
              attrs: { src: "/static/img/media/media-thairath.jpg" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href:
                "http://blog.beneat.co/wp-content/uploads/2017/06/13958208_272931419766182_8977123761692973895_o.jpg",
              target: "_blank"
            }
          },
          [
            _c("img", {
              staticClass: "img-media",
              attrs: { src: "/static/img/media/media-daylinews.jpg" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "http://daily.bangkokbiznews.com/detail/265722",
              target: "_blank"
            }
          },
          [
            _c("img", {
              staticClass: "img-media",
              attrs: { src: "/static/img/media/media-bkkbiznews.jpg" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "http://money.kapook.com/view156079.html",
              target: "_blank"
            }
          },
          [
            _c("img", {
              staticClass: "img-media",
              attrs: { src: "/static/img/media/media-kapook.jpg" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "http://news.mthai.com/hot-news/economy-news/517534.html",
              target: "_blank"
            }
          },
          [
            _c("img", {
              staticClass: "img-media",
              attrs: { src: "/static/img/media/media-mthai.jpg" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://www.facebook.com/longtunman/photos/a.113656345833649/1029004597632148/",
              target: "_blank"
            }
          },
          [
            _c("img", {
              staticClass: "img-media",
              attrs: { src: "/static/img/media/media-longthunman.jpg" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://www.cleverthai.com/best-maid-service-bangkok/#BeNeat",
              target: "_blank"
            }
          },
          [
            _c("img", {
              staticClass: "img-media-square",
              attrs: { src: "/static/img/media/media-cleverthai.jpg" }
            })
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78ff1ed3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ff1ed3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionPartner.vue
// module id = 1496
// module chunks = 0